import { TracingResponse } from '../types/Api';

export const handleDownloadJson = (json: TracingResponse) => {
  const jsonStr = JSON.stringify({trace_events:json}, null, 2)
  const blob = new Blob([jsonStr], { type: 'application/json' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'data.json'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
